import angular from 'angular';

/* @ngInject */
export default function BuilderController($scope, $window, SideMenuCacheService, DefinitionParameterApiService, CacheService, SleuthService) {
    $scope.filteredDefinitions = [];

    // If the definitions are already in the cache, grab them out.
    if (CacheService.getAllDefinitions()) {
        $scope.definitions = CacheService.getAllDefinitions();
        $scope.filteredDefinitions = $scope.definitions;
    }

    $scope.$watch(
        function () {
            return CacheService.getDefinition();
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.init();
            }
        }
    );

    $scope.init = function () {
        if (CacheService.getDefinition() !== undefined && CacheService.getDefinition().id !== 0) {
            DefinitionParameterApiService.getDefinitionParameterByDefinitionAndDisplayArea(
                CacheService.getDefinition().id,
                'PARAMETRIC_BUILDER',
                function (definitionParameters) {
                    SideMenuCacheService.sidemenu.length = 0;
                    angular.forEach(definitionParameters, function (value, key) {
                        if (value.parameterValues.length === 0) {
                            return;
                        }
                        SideMenuCacheService.sidemenu.push(value);
                        SleuthService.fillMenuValue(value);
                    });
                    $scope.filters = SideMenuCacheService.sidemenu;
                    $scope.filters.forEach((filter) => {
                        if (filter.parameterValues.length > 1
                            && /\d/.test(filter.parameterValues[0].value)
                            && filter.sorted === undefined) {
                            // filter.parameterValues.sort($scope.parameterValueComparator);
                            filter.sorted = true;
                        }
                    });
                }, function (error) {
                    console.error('An error occurred while getting Definition Parameter by ' + CacheService.getDefinition().id + ' Definition and PARAMETRIC_BUILDER displayArea', error);
                });
        }
    };

    $scope.parameterValueComparator = function (a, b){
        const aInterpreted = $scope.mapParameterValueToNumericPresentable(a);
        const bInterpreted = $scope.mapParameterValueToNumericPresentable(b);
        // compare as numeric if both parameter values have the first numeric expression match at the same index
        if (aInterpreted.startIndex === bInterpreted.startIndex
            && aInterpreted.vals.length > 0 && bInterpreted.vals.length > 0) {
            // % ranks higher than others
            if (a.value.indexOf('%') > -1 && b.value.indexOf('%') <= -1) {
                return -1;
            } else if (a.value.indexOf('%') <= -1 && b.value.indexOf('%') > -1) {
                return 1;
            }
            // sort by priority of numeric presentation
            else if (aInterpreted.priority < bInterpreted.priority) {
                return -1;
            } else if (aInterpreted.priority > bInterpreted.priority) {
                return 1;
            }
            // numeric comparison
            else {
                let i;
                for (i = 0; i < aInterpreted.vals.length; i++) {
                    if (aInterpreted.vals[i] < bInterpreted.vals[i]) {
                        return -1;
                    } else if (aInterpreted.vals[i] > bInterpreted.vals[i]) {
                        return 1;
                    }
                }
                return a.value.localeCompare(b.value);
            }
        } else {
            return a.value.localeCompare(b.value);
        }
    };

    $scope.mapParameterValueToNumericPresentable = function (parameterValue) {
        let startIndex;
        let priority = 0;
        const regex = /((?:<|>|\+\/\-|\+|\-)*)(\d+(?:\.\d+)?)/g;
        const matchVals = [];
        let match;
        while ( (match = regex.exec(parameterValue.value)) !== null) {
            startIndex = match.index;
            let val = parseFloat(match[2]);
            if (match[1].indexOf('<')) {
                val = val - (val * 0.001);
            }
            if (match[1].indexOf('-') > -1 && match[1].indexOf('+/-') <= -1) {
                val = val * -1;
            }
            if (match[1].indexOf('<')) {
                val = val - (Math.abs(val) * 0.001);
            }
            if (match[1].indexOf('>')) {
                val = val + (Math.abs(val) * 0.001);
            }
            // interpret si prefixes
            const siRegex = /((?:k|m|g))hz/;
            const siMatch = siRegex.exec(parameterValue.value.toLowerCase());
            if (siMatch !== null) {
                if (siMatch[1] === 'k') {
                    val = val * 10E3;
                } else if (siMatch[1] === 'm') {
                    val = val * 10E6;
                } else if (siMatch[1] === 'g') {
                    val = val * 10E9;
                }
            }
            matchVals.push(val);
        };
        // sort by number of numeric presentation
        priority = priority + matchVals.length;
        // lower priority when it is a dimension presentation e.g. 22x1.5
        const dimensionRegex = /\d+(?:\.\d+)?x\d+(?:\.\d+)?/g;
        const dimensionMatch = dimensionRegex.exec(parameterValue.value.toLowerCase());
        if (dimensionMatch !== null) {
            priority = priority + 0.5;
        }
        return {
            vals: matchVals,
            startIndex: startIndex,
            priority: priority
        };
    };

    $scope.init();

    $scope.focusOnInput = function (filter) {
        "use strict";
        filter.hasFocus = true;
    };

    $scope.unFocusOnInput = function (filter) {
        "use strict";
        filter.hasFocus = false;
    };
}
